<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText
        v-if="fields?.title?.value"
        tag="h2"
        class="lecturer-introduction-title"
        :field="fields?.title"
      />
      <div :class="listClasses" v-if="fields?.list?.length > 0">
        <div class="lecturer-introduction-list-item" v-for="item in fields?.list" :key="item.id">
          <AdaptiveImage
            class="lecturer-introduction-list-item-image"
            :field="item?.fields?.avatar"
            :lazy-load="false"
            :enableScrollDetection="false"
            :show="true"
          />
          <div class="lecturer-introduction-list-item-content">
            <JssRichText
              class="lecturer-introduction-list-item-content-name"
              :field="item?.fields?.name"
            />
            <JssRichText
              class="lecturer-introduction-list-item-content-job"
              :field="item?.fields?.jobtitle"
            />
            <JssRichText
              class="lecturer-introduction-list-item-content-introduction"
              :field="item?.fields?.introduction"
            />
          </div>
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';
import { isNullOrEmpty } from '@/utils/obj-utils';

export default {
  name: 'LecturerIntroduction',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() =>
      utils.overall.baseComClass(props.fields, 'lecturer-introduction')
    );

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    const listClasses = computed(() => {
      const list = props.fields?.list || [];
      const hasIntroduction = list.some(
        (item) => !isNullOrEmpty(item?.fields?.introduction?.value)
      );
      const slides = parseInt(props.fields?.videwSlides?.value) || 2;
      const slidesClass = hasIntroduction ? '' : `slides-${slides}`;
      return [
        'lecturer-introduction-list',
        { 'no-introduction': !hasIntroduction, [slidesClass]: slidesClass },
      ];
    });

    return {
      rootClass,
      rootStyle,
      listClasses,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.lecturer-introduction {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    margin-bottom: 24px;
    text-align: center;
  }

  &-list {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    gap: 24px;

    &.no-introduction {
      flex-direction: row;
      justify-content: flex-start;

      .lecturer-introduction-list-item {
        width: calc(50% - 12px);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        text-align: center;
      }
    }

    &-item {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 20px;

      &-image {
        width: 100px;
        height: 100px;
        object-fit: cover;
        border-radius: 100%;
      }

      &-content {
        flex: 1;

        &-name {
          font-size: 24px;
          font-weight: 700;
          color: $black;
          margin-bottom: 12px;
          line-height: 1.4;
        }

        &-job {
          font-size: 16px;
          color: $black;
          line-height: 1.6;
          margin-top: 8px;
        }

        &-introduction {
          font-size: 16px;
          color: $black;
          line-height: 1.4;
          margin-top: 24px;
        }
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-list {
      gap: 40px;

      &.no-introduction {
        justify-content: flex-start;

        .lecturer-introduction-list-item {
          flex-direction: column;
          gap: 20px;
        }

        &.slides-2 .lecturer-introduction-list-item {
          width: calc(50% - 20px);
        }

        &.slides-3 .lecturer-introduction-list-item {
          width: calc(33.33% - 26.66px);
        }

        &.slides-4 .lecturer-introduction-list-item {
          width: calc(25% - 30px);
        }
      }

      &-item {
        align-items: center;
        gap: 50px;
        flex-direction: row;

        &-image {
          width: 134px;
          height: 134px;
        }
      }
    }
  }
}
</style>
